(function($, undefined) {
	'use strict';
	var header;

	var openPopup = function(p) {
		var id = $(this).attr('data-id');
		var popup;

		p.length !== undefined ? popup = p : popup = $('.popup[data-id="'+id+'"]');

		popup.addClass('open');
		if (!popup.hasClass('no-overlay')) {
			$('body').addClass('popup-show');
		}
		if (!popup.hasClass('scroll-enabled')) {
			header.removeScroll();
		}
		if (popup.find('.init-addthis').length > 0) {
			popup.find('.init-addthis').addClass(popup.find('.init-addthis').attr('data-class'));
			addthis.layers.refresh();
		}
	};

	var closePopup = function() {
		//Le popup ne perd pas sa class .open
		var popup = $(this).closest('.popup');

		popup.removeClass('open');
		if (!popup.hasClass('no-overlay')) {
			$('body').removeClass('popup-show');
		}
		if (!popup.hasClass('scroll-enabled')) {
			header.addScroll();
		}
		popup.trigger("popup_closed");
	};
	
	var closeAllPopup = function () {
		$('.popup').removeClass('open');
		$('body').removeClass('popup-show');
		header.addScroll();
		
		var currentPopup = $(this).closest('.popup');
		if (currentPopup) {
			currentPopup.trigger("popup_closed");
		}
	};

	var init = function() {
		header = Fw.modules.models().header;
		
		$('body').on('click', '.popup-btn', openPopup);
		$('body').on('click', '.js-popup-close-btn', closeAllPopup);
	};
	
	$(window).ready(function () {
		init();
	});

	var popup = Fw.component.export('popup', {
		openPopup: openPopup,
		closePopup: closePopup,
		closeAllPopup: closeAllPopup
	});

})(jQuery);

